/**
 * TWO brand mark: two circles side by side. The first is a faint soft-blue disc with a visible
 * hairline (`line-strong`, at least 3:1 against surface and elevated in both themes, 1.25 units
 * so it still paints at 16px), the second TWO Blue. Sizes 16 / 24 / 32. `tone="muted"` dims
 * the first circle only (inactive navigation): the second circle stays TWO Blue in every state
 * (Brand v1.2, M5.2). Decorative: hidden from assistive tech.
 */
export function BrandMark({
  size = 24,
  className = '',
  tone = 'brand',
}: {
  size?: 16 | 24 | 32;
  className?: string;
  tone?: 'brand' | 'muted';
}) {
  return (
    <svg
      viewBox="0 0 24 12"
      width={size}
      height={size / 2}
      className={['shrink-0', className].join(' ')}
      aria-hidden
      focusable={false}
      data-tone={tone}
    >
      {tone === 'muted' ? (
        <circle
          cx="6"
          cy="6"
          r="5"
          className="fill-none stroke-ink-3"
          strokeWidth="1.25"
          data-circle="first"
        />
      ) : (
        <circle
          cx="6"
          cy="6"
          r="5"
          className="fill-brand-soft stroke-line-strong"
          strokeWidth="1.25"
          data-circle="first"
        />
      )}
      <circle cx="18" cy="6" r="5.5" className="fill-brand" data-circle="second" />
    </svg>
  );
}
